const { create } = require("zustand");

export const useLoginStore = create((set) => ({
    email: '',
    password: '',

    changeEmail: ({ target: { value } }) => set(() => ({ email: value })),
    changePassword: ({ target: { value } }) => set(() => ({ password: value })),
}))